// extracted by mini-css-extract-plugin
export default {"providers":"SignIn_providers__0sJJc","webIdForm":"SignIn_webIdForm__0gGWd"};